import axios, { AxiosRequestConfig } from 'axios';
import {
    CarryApiResult, CarryJob, CarryPreview, CarryRequest, CarryResponse, CarryTarget,
} from '../types/coachCarry';

const request = async <T>(accessToken: string, config: AxiosRequestConfig): Promise<CarryApiResult<T>> => {
    try {
        const response = await axios({
            ...config,
            url: `${process.env.REACT_APP_SERVER}/v1/centers/${config.url}`,
            headers: { authorization: accessToken },
        });
        return { status: response.status, data: response.data };
    } catch (error: any) {
        return { status: error?.response?.status ?? 0, data: error?.response?.data ?? {} };
    }
};

const carryPath = (centerId: string, coachId: string) =>
    `${encodeURIComponent(centerId)}/coaches/${encodeURIComponent(coachId)}/carry-out`;

export const getCarryTargetsAPI = (centerId: string, coachId: string, accessToken: string) =>
    request<{ targets: CarryTarget[] }>(accessToken, { method: 'get', url: `${carryPath(centerId, coachId)}/targets` });

export const previewCarryAPI = (centerId: string, coachId: string, toCenterId: string, accessToken: string) =>
    request<CarryPreview>(accessToken, {
        method: 'post', url: `${carryPath(centerId, coachId)}/preview`, data: { toCenterId }, readOnlySafe: true,
    });

export const executeCarryAPI = (centerId: string, coachId: string, body: CarryRequest, accessToken: string) =>
    request<CarryResponse>(accessToken, { method: 'post', url: carryPath(centerId, coachId), data: body });

export const getCarryJobAPI = (centerId: string, jobId: string, accessToken: string) =>
    request<{ job: CarryJob }>(accessToken, {
        method: 'get', url: `${encodeURIComponent(centerId)}/carry-jobs/${encodeURIComponent(jobId)}`,
    });
